'use client';

import { CHANNEL_META } from './ChannelIcons';
import { HERO_CTA_ENABLED } from '@/lib/onboarding/hero-cta-env';

interface Stat {
  value: string;
  label: string;
  desc: string;
  color: string;
  showChannelIcons?: boolean;
}

// Compile-time gate (NEXT_PUBLIC, baked at build): with the hero CTA live —
// the call flag OR a message number (Wave H1) — the first proof tile tells
// the conversation-first story instead of the template one.
const heroCtaEnabled = HERO_CTA_ENABLED;

const stats: Stat[] = [
  heroCtaEnabled
    ? { value: '~30 s', label: 'to meet Tessa', desc: 'Text her or type your number — she drafts your first check-in from that conversation', color: '#EF4444' }
    : { value: '2 min', label: 'to set up', desc: 'From template to scheduled routine', color: '#EF4444' },
  { value: '5–10 min', label: 'per check-in', desc: "On each person's own time — not yours", color: '#10B981' },
  { value: '6', label: 'channels to reach them', desc: 'Calls, texts, WhatsApp, email, Slack, web calls — and she books follow-ups straight into calendars.', color: '#3B82F6', showChannelIcons: true },
  { value: '$0', label: 'per invited member', desc: "You're never charged for someone Tessa calls", color: '#8B5CF6' },
];

export default function TrendSection() {
  return (
    <section className="py-14">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {stats.map((stat) => (
            <div
              key={stat.value}
              className="text-center py-7 px-4 bg-card border border-border rounded-[16px] transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div
                className="text-[28px] md:text-[36px] font-bold tracking-[-1.5px] leading-none mb-1.5"
                style={{ color: stat.color }}
              >
                {stat.value}
              </div>
              {stat.showChannelIcons && (
                <div className="flex flex-wrap items-center justify-center gap-1.5 text-muted-foreground mb-1.5" aria-hidden="true">
                  {CHANNEL_META.filter(({ key }) => key !== 'calendar').map(({ key, Icon }) => (
                    <Icon key={key} className="w-4 h-4" />
                  ))}
                </div>
              )}
              <div className="font-semibold text-[14px] text-foreground mb-0.5">{stat.label}</div>
              <div className="text-[12px] text-muted-foreground">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
